import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { authGuard } from './guard/auth.guard';
import { ModuloGuard } from './guards/modulo.guard';
import { PerfilComponent } from './pages/perfil/perfil.component';

const routes: Routes = [
  {
    path: '',
    component: FullComponent,
    data: { breadcrumb: 'Home' },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./pages/pages.module').then((m) => m.PagesModule),
        data: {
          reloadComponent: true,
        },
        canMatch: [authGuard],
      },
      {
        path: 'perfil',
        component: PerfilComponent,
        data: {
          title: 'Perfil',
          urls: [{ title: 'Perfil', url: 'perfil' }, { title: 'Perfil' }],
        },
        canMatch: [authGuard],
      },
      {
        path: 'cliente',
        loadChildren: () =>
          import('./pages/cadastros/cliente/cliente.module').then(
            (m) => m.ClienteModule
          ),
        data: {
          modulo: 'cliente', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'funcionario-fixo',
        loadChildren: () =>
          import(
            './pages/cadastros/funcionarios/fixo/funcionario-fixo.module'
          ).then((m) => m.FuncionarioFixoModule),
        data: {
          modulo: 'funcionario-fixo', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'funcionario-administrativo',
        loadChildren: () =>
          import(
            './pages/cadastros/funcionarios/administrativo/funcionario-administrativo.module'
          ).then((m) => m.FuncionarioAdministrativoModule),
        data: {
          modulo: 'funcionario-administrativo', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'funcionario-encarregado',
        loadChildren: () =>
          import(
            './pages/cadastros/funcionarios/encarregado/funcionario-encarregado.module'
          ).then((m) => m.FuncionarioEncarregadoModule),
        data: {
          modulo: 'funcionario-encarregado', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'todos-funcionarios',
        loadChildren: () =>
          import(
            './pages/cadastros/funcionarios/todos/funcionario-todos.module'
          ).then((m) => m.FuncionarioTodosModule),
        data: {
          modulo: 'todos-funcionarios', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'regional-fazenda',
        loadChildren: () =>
          import(
            './pages/cadastros/dados-fazenda/regional-fazenda/regional-fazenda.module'
          ).then((m) => m.RegionalFazendaModule),
        data: {
          modulo: 'regional-fazenda', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'fazenda-geojson',
        loadChildren: () =>
          import(
            './pages/cadastros/dados-fazenda-geojson/fazenda-geojson.module'
          ).then((m) => m.FazendaGeoJsonModule),
        data: {
          //modulo: 'regional-fazenda',
        },
        canMatch: [authGuard],
        //canActivate: [ModuloGuard],
      },
      {
        path: 'safra',
        loadChildren: () =>
          import('./pages/cadastros/dados-fazenda/safras/safra.module').then(
            (m) => m.SafraModule
          ),
        data: {
          modulo: 'safra', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'campo-carretinha',
        loadChildren: () =>
          import(
            './pages/cadastros/dados-fazenda/regional-fazenda/campo-carretinha/campo-carretinha.module'
          ).then((m) => m.CampoCarretinhaModule),
        data: {
          modulo: 'regional-fazenda',
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      // {
      //   path: 'colheita',
      //   loadChildren: () =>
      //     import(
      //       './pages/cadastros/dados-colheita/colheita/colheita.module'
      //     ).then((m) => m.ColheitaModule),
      //   data: {
      //   },
      //   canMatch: [authGuard],
      // },
      {
        path: 'turma',
        loadChildren: () =>
          import('./pages/cadastros/dados-colheita/turma/turma.module').then(
            (m) => m.TurmaModule
          ),
        data: {
          modulo: 'turma', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'colhedor',
        loadChildren: () =>
          import(
            './pages/cadastros/dados-colheita/colhedor/colhedor.module'
          ).then((m) => m.ColhedorModule),
        data: {
          modulo: 'colhedor', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'transferir-colhedor',
        loadChildren: () =>
          import(
            './pages/cadastros/dados-colheita/transferir-colhedores/transferir-colhedores.module'
          ).then((m) => m.TransferirColhedoresModule),
        data: {
          modulo: 'transferir-colhedor', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'transferir-turma',
        loadChildren: () =>
          import(
            './pages/cadastros/dados-colheita/transferir-turma/transferir-turma.module'
          ).then((m) => m.TransferirTurmaModule),
        data: {
          modulo: 'transferir-turma', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'talhao',
        loadChildren: () =>
          import('./pages/cadastros/talhao/talhao.module').then(
            (m) => m.TalhaoModule
          ),
        data: {
          modulo: 'talhao', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'entrada',
        loadChildren: () =>
          import('./pages/cadastros/estoque/entrada/entrada.module').then(
            (m) => m.EntradaModule
          ),
        data: {
          modulo: 'entrada', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'transferencia-estoque',
        loadChildren: () =>
          import(
            './pages/cadastros/estoque/transferencia-estoque/transferencia-estoque.module'
          ).then((m) => m.TransferenciaEstoqueModule),
        data: {
          modulo: 'transferencia-estoque', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'ajuste-estoque',
        loadChildren: () =>
          import(
            './pages/cadastros/estoque/ajuste-estoque/ajuste-estoque.module'
          ).then((m) => m.AjusteEstoqueModule),
        data: {
          modulo: 'ajuste-estoque', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'listagem-estoque',
        loadChildren: () =>
          import(
            './pages/cadastros/estoque/listagem-estoque/listagem-estoque.module'
          ).then((m) => m.ListagemEstoqueModule),
        data: {
          modulo: 'listagem-estoque', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'parametros-aplicativo',
        loadChildren: () =>
          import(
            './pages/cadastros/parametro-aplicativo/parametro-aplicativo.module'
          ).then((m) => m.ParametroAplicativoModule),
        data: {
          modulo: 'parametros-aplicativo', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'parametros-pulverizacao',
        loadChildren: () =>
          import(
            './pages/cadastros/parametros/pulverizacao/parametros-pulverizacao.module'
          ).then((m) => m.ParametroPulverizacaoModule),
        data: {
          modulo: 'parametros-pulverizacao', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'parametros-herbicida',
        loadChildren: () =>
          import(
            './pages/cadastros/parametros/herbicida/parametros-herbicida.module'
          ).then((m) => m.ParametroHerbicidaModule),
        data: {
          modulo: 'parametros-herbicida', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'parametros-adubacao',
        loadChildren: () =>
          import(
            './pages/cadastros/parametros/adubacao/parametros-adubacao.module'
          ).then((m) => m.ParametroAdubacaoModule),
        data: {
          modulo: 'parametros-adubacao', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'parametros-drench',
        loadChildren: () =>
          import(
            './pages/cadastros/parametros/drench/parametros-drench.module'
          ).then((m) => m.ParametroDrenchModule),
        data: {
          modulo: 'parametros-drench', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'parametros-tratos',
        loadChildren: () =>
          import(
            './pages/cadastros/parametros/tratos/parametros-tratos.module'
          ).then((m) => m.ParametroTratosModule),
        data: {
          modulo: 'parametros-tratos', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'parametros-frota',
        loadChildren: () =>
          import(
            './pages/cadastros/parametros/frotas/parametros-frota.module'
          ).then((m) => m.ParametroFrotaModule),
        data: {
          modulo: 'parametros-frota', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'veiculo-implemento',
        loadChildren: () =>
          import(
            './pages/cadastros/frotas-implementos/veiculo-implemento/veiculo-implemento.module'
          ).then((m) => m.VeiculoImplementoModule),
        data: {
          modulo: 'veiculo-implemento', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'parametros-produto',
        loadChildren: () =>
          import(
            './pages/cadastros/parametros/produtos/parametros-produto.module'
          ).then((m) => m.ParametroProdutoModule),
        data: {
          modulo: 'parametros-produto', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'produto',
        loadChildren: () =>
          import('./pages/cadastros/produtos/produto/produto.module').then(
            (m) => m.ProdutoModule
          ),
        data: {
          modulo: 'produto', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'tratamento-alvo',
        loadChildren: () =>
          import(
            './pages/cadastros/tratamento-alvo/tratamento-alvo.module'
          ).then((m) => m.TratamentoAlvoModule),
        data: {
          modulo: 'tratamento-alvo', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'modulos',
        loadChildren: () =>
          import('./pages/cadastros/acessos/modulo/modulo.module').then(
            (m) => m.ModuloModule
          ),
        data: {
          modulo: 'modulos', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'cargos',
        loadChildren: () =>
          import('./pages/cadastros/parametros/cargo/cargo.module').then(
            (m) => m.CargoModule
          ),
        data: {
          modulo: 'cargos', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'grupos-cargo',
        loadChildren: () =>
          import(
            './pages/cadastros/parametros/grupo-cargo/grupo-cargo.module'
          ).then((m) => m.GrupoCargoModule),
        data: {
          modulo: 'grupos-cargo', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'motorista',
        loadChildren: () =>
          import('./pages/cadastros/fretes/motorista/motorista.module').then(
            (m) => m.MotoristaModule
          ),
        data: {
          modulo: 'motorista', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'fabrica',
        loadChildren: () =>
          import('./pages/cadastros/fretes/fabrica/fabrica.module').then(
            (m) => m.FabricaModule
          ),
        data: {
          modulo: 'fabrica', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'transportadora',
        loadChildren: () =>
          import(
            './pages/cadastros/fretes/transportadora/transportadora.module'
          ).then((m) => m.TransportadoraModule),
        data: {
          modulo: 'transportadora', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'veiculo-frete',
        loadChildren: () =>
          import(
            './pages/cadastros/fretes/veiculo-frete/veiculo-frete.module'
          ).then((m) => m.VeiculoFreteModule),
        data: {
          modulo: 'veiculo-frete', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'frete',
        loadChildren: () =>
          import('./pages/cadastros/fretes/frete/frete.module').then(
            (m) => m.FreteModule
          ),
        data: {
          modulo: 'frete', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'frete-colheita',
        loadChildren: () =>
          import(
            './pages/cadastros/fretes/frete-colheita/frete-colheita.module'
          ).then((m) => m.FreteColheitaModule),
        data: {
          modulo: 'frete-colheita', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'turno',
        loadChildren: () =>
          import('./pages/cadastros/parametros/turno/turno.module').then(
            (m) => m.TurnoModule
          ),
        data: {
          modulo: 'turno', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'parametro-valor-caixa-colhedor',
        loadChildren: () =>
          import('./pages/cadastros/dados-colheita/parametro-valor-caixa/parametro-valor-caixa.module').then(
            (m) => m.ParametroValorCaixaModule
          ),
        data: {
          modulo: 'parametro-valor-caixa-colhedor', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'usuario',
        loadChildren: () =>
          import('./pages/cadastros/acessos/usuario/usuario.module').then(
            (m) => m.UsuarioModule
          ),
        data: {
          modulo: 'usuario', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'classe-geral',
        loadChildren: () =>
          import(
            './pages/cadastros/tecnicos/classes/classe-geral/classe-geral.module'
          ).then((m) => m.ClasseGeralModule),
        data: {
          modulo: 'classe', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'campo',
        loadChildren: () =>
          import('./pages/cadastros/tecnicos/campo/campo.module').then(
            (m) => m.CampoModule
          ),
        data: {
          modulo: 'campo', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'classe-pulverizacao',
        loadChildren: () =>
          import(
            './pages/cadastros/tecnicos/classes/classe-pulverizacao/classe-pulverizacao.module'
          ).then((m) => m.ClassePulverizacaoModule),
        data: {
          modulo: 'classe', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'classe-herbicida',
        loadChildren: () =>
          import(
            './pages/cadastros/tecnicos/classes/classe-herbicida/classe-herbicida.module'
          ).then((m) => m.ClasseHerbicidaModule),
        data: {
          modulo: 'classe', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'classes',
        loadChildren: () =>
          import('./pages/cadastros/tecnicos/classes/classes.module').then(
            (m) => m.ClassesModule
          ),
        data: {
          modulo: 'classes', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'classe-corretivo',
        loadChildren: () =>
          import(
            './pages/cadastros/tecnicos/classes/classe-corretivo/classe-corretivo.module'
          ).then((m) => m.ClasseCorretivoModule),
        data: {
          modulo: 'classe', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'classe-drench',
        loadChildren: () =>
          import(
            './pages/cadastros/tecnicos/classes/classe-drench/classe-drench.module'
          ).then((m) => m.ClasseDrenchModule),
        data: {
          modulo: 'classe', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'clientes-modulos',
        loadComponent: () =>
          import('./pages/agrocontrole/clientes-modulos/clientes-modulos.component').then(
            (m) => m.ClientesModulosComponent
          ),
        data: {
          title: 'Gestão de Módulos por Cliente',
          // Comentado temporariamente para desenvolvimento
          modulo: 'clientes-modulos', // Usado pelo ModuloGuard
        },
        // Comentado temporariamente para desenvolvimento
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'usuarios-acesso',
        loadComponent: () =>
          import('./pages/cadastros/acessos/usuarios-acesso/usuarios-acesso.component').then(
            (m) => m.UsuariosAcessoComponent
          ),
        data: {
          title: 'Gestão de Usuários e Acessos',
          // Comentado temporariamente para desenvolvimento
          modulo: 'usuarios-acesso', // Usado pelo ModuloGuard
        },
        // Comentado temporariamente para desenvolvimento
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'pulverizacao-lancamento',
        loadChildren: () =>
          import(
            './pages/lancamentos/pulverizacao/pulverizacao-lancamento.module'
          ).then((m) => m.PulverizacaoLancamentoModule),
        data: {
          modulo: 'pulverizacao-lancamento', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'pulverizacao-lancamento-gerenciar',
        loadChildren: () =>
          import(
            './pages/lancamentos/pulverizacao-gerenciar/pulverizacao-lancamento-gerenciar.module'
          ).then((m) => m.PulverizacaoLancamentoGerenciarModule),
        data: {
          modulo: 'pulverizacao-lancamento-gerenciar', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'colheita-lancamento',
        loadChildren: () =>
          import(
            './pages/lancamentos/colheita/colheita-lancamento.module'
          ).then((m) => m.ColheitaLancamentoModule),
        data: {
          modulo: 'colheita-lancamento', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'colheita-lancamento-gerenciar',
        loadChildren: () =>
          import(
            './pages/lancamentos/colheita-gerenciar/colheita-lancamento-gerenciar.module'
          ).then((m) => m.ColheitaLancamentoGerenciarModule),
        data: {
          modulo: 'colheita-lancamento-gerenciar', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'herbicida-lancamento',
        loadChildren: () =>
          import(
            './pages/lancamentos/herbicida/herbicida-lancamento.module'
          ).then((m) => m.HerbicidaLancamentoModule),
        data: {
          modulo: 'herbicida-lancamento', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'adubacao-lancamento',
        loadChildren: () =>
          import(
            './pages/lancamentos/adubacao/adubacao-lancamento.module'
          ).then((m) => m.AdubacaoLancamentoModule),
        data: {
          modulo: 'adubacao-lancamento', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'abastecimento-lancamento-gerenciar',
        loadChildren: () =>
          import(
            './pages/lancamentos/abastecimento-gerenciar/abastecimento-lancamento-gerenciar.module'
          ).then((m) => m.AbastecimentoLancamentoGerenciarModule),
        data: {
          requiredPermissions: ['regional'],
          modulo: 'abastecimento-lancamento-gerenciar', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'drench-lancamento-gerenciar',
        loadChildren: () =>
          import(
            './pages/lancamentos/drench-gerenciar/drench-lancamento-gerenciar.module'
          ).then((m) => m.DrenchLancamentoGerenciarModule),
        data: {
          requiredPermissions: ['regional'],
          modulo: 'drench-lancamento-gerenciar', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'herbicida-lancamento-gerenciar',
        loadChildren: () =>
          import(
            './pages/lancamentos/herbicida-gerenciar/herbicida-lancamento-gerenciar.module'
          ).then((m) => m.HerbicidaLancamentoGerenciarModule),
        data: {
          requiredPermissions: ['regional'],
          modulo: 'herbicida-lancamento-gerenciar', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'adubacao-lancamento-gerenciar',
        loadChildren: () =>
          import(
            './pages/lancamentos/adubacao-gerenciar/adubacao-lancamento-gerenciar.module'
          ).then((m) => m.AdubacaoLancamentoGerenciarModule),
        data: {
          modulo: 'adubacao-lancamento-gerenciar', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'drench-lancamento',
        loadChildren: () =>
          import('./pages/lancamentos/drench/drench-lancamento.module').then(
            (m) => m.DrenchLancamentoModule
          ),
        data: {
          modulo: 'drench-lancamento', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'abastecimento-lancamento',
        loadChildren: () =>
          import(
            './pages/lancamentos/abastecimento/abastecimento-lancamento.module'
          ).then((m) => m.AbastecimentoLancamentoModule),
        data: {
          modulo: 'abastecimento-lancamento', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'troca-oleo-lancamento',
        loadChildren: () =>
          import(
            './pages/lancamentos/troca-oleo/troca-oleo-lancamento.module'
          ).then((m) => m.TrocaOleoLancamentoModule),
        data: {
          modulo: 'troca-oleo-lancamento', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'tratos-lancamento',
        loadChildren: () =>
          import('./pages/lancamentos/tratos/tratos-lancamento.module').then(
            (m) => m.TratosLancamentoModule
          ),
        data: {
          modulo: 'tratos-lancamento', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'estoque-insumos-lancamento',
        loadChildren: () =>
          import(
            './pages/lancamentos/estoque-insumos/estoque-insumos-lancamento.module'
          ).then((m) => m.EstoqueInsumosModule),
        data: {
          modulo: 'estoque-insumos-lancamento', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'praga',
        loadChildren: () =>
          import('./pages/cadastros/praga/praga.module').then(
            (m) => m.PragaModule
          ),
        data: {
          modulo: 'praga', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'armadilha',
        loadChildren: () =>
          import('./pages/cadastros/armadilha/armadilha.module').then(
            (m) => m.ArmadilhaModule
          ),
        data: {
          modulo: 'armadilha', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'armadilha-pragas-lancamento',
        loadChildren: () =>
          import(
            './pages/lancamentos/armadilha-praga/armadilha-praga-lancamento.module'
          ).then((m) => m.ArmadilhaPragaLancamentoModule),
        data: {
          modulo: 'armadilha-pragas-lancamento', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'armadilha-pragas-lancamento-gerenciar',
        loadChildren: () =>
          import(
            './pages/lancamentos/armadilha-praga-gerenciar/armadilha-praga-lancamento-gerenciar.module'
          ).then((m) => m.ArmadilhaPragaLancamentoGerenciarModule),
        data: {
          modulo: 'armadilha-pragas-lancamento-gerenciar', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'status-os',
        loadChildren: () =>
          import('./pages/cadastros/oficina/status-os/status-os.module').then(
            (m) => m.statusOsModule
          ),
        data: {
          modulo: 'status-os', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'fornecedor',
        loadChildren: () =>
          import('./pages/cadastros/oficina/fornecedor/fornecedor.module').then(
            (m) => m.fornecedorModule
          ),
        data: {
          modulo: 'fornecedor', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'nota-fiscal',
        loadChildren: () =>
          import(
            './pages/cadastros/oficina/nota-fiscal/nota-fiscal.module'
          ).then((m) => m.notaFiscalModule),
        data: {
          modulo: 'nota-fiscal', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'ordem-servico',
        loadChildren: () =>
          import(
            './pages/cadastros/oficina/ordem-servico/ordem-servico.module'
          ).then((m) => m.OrdemServicoModule),
        data: {
          modulo: 'ordem-servico', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      // Esg Clima
      {
        path: 'item-coleta',
        loadChildren: () =>
          import(
            './pages/cadastros/esg-clima/item-coleta/item-coleta.module'
          ).then((m) => m.ItemColetaModule),
        data: {
          modulo: 'item-coleta', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'local-coleta',
        loadChildren: () =>
          import(
            './pages/cadastros/esg-clima/local-coleta/local-coleta.module'
          ).then((m) => m.LocalColetaModule),
        data: {
          modulo: 'local-coleta', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'lancamentos-esg-clima',
        loadChildren: () =>
          import(
            './pages/cadastros/esg-clima/lancamentos/lancamentos-esg-clima.module'
          ).then((m) => m.LancamentosEsgClimaModule),
        data: {
          modulo: 'lancamentos-esg-clima', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      // Financeiro
      {
        path: 'financeiro',
        loadChildren: () =>
          import(
            './pages/cadastros/financeiro/financeiro.module'
          ).then((m) => m.FinanceiroModule),
        canMatch: [authGuard],
      },
      {
        path: 'tipo-manutencao',
        loadChildren: () =>
          import(
            './pages/cadastros/parametros/tipo-manutencao/tipo-manutencao.module'
          ).then((m) => m.tipoManutencaoModule),
        data: {
          modulo: 'tipo-manutencao', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'tipo-manutencao-oficina',
        loadChildren: () =>
          import(
            './pages/cadastros/oficina/tipo-manutencao-oficina/tipo-manutencao-oficina.module'
          ).then((m) => m.TipoManutencaoOficinaModule),
        data: {
          modulo: 'tipo-manutencao-oficina', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'centro-custo',
        loadChildren: () =>
          import(
            './pages/cadastros/parametros/centro-custo/centro-custo.module'
          ).then((m) => m.CentroCustoModule),
        data: {
          modulo: 'centro-custo', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'oficina-lancamento',
        loadChildren: () =>
          import('./pages/lancamentos/oficina/oficina-lancamento.module').then(
            (m) => m.OficinaLancamentoModule
          ),
        data: {
          modulo: 'oficina-lancamento', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'telemetria-consulta',
        loadChildren: () =>
          import(
            './pages/lancamentos/telemetria/telemetria-lancamento.module'
          ).then((m) => m.TelemetriaLancamentoModule),
        data: {
          modulo: 'telemetria-consulta',
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'tipo-atividade-telemetria',
        loadChildren: () =>
          import(
            './pages/cadastros/telemetria/tipo-atividade-telemetria/tipo-atividade-telemetria.module'
          ).then((m) => m.TipoAtividadeTelemetriaModule),
        data: {
          modulo: 'tipo-atividade-telemetria', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'tipo-parada-telemetria',
        loadChildren: () =>
          import(
            './pages/cadastros/telemetria/tipo-parada-telemetria/tipo-parada-telemetria.module'
          ).then((m) => m.TipoParadaTelemetriaModule),
        data: {
          modulo: 'tipo-parada-telemetria', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'tipo-outro-telemetria',
        loadChildren: () =>
          import(
            './pages/cadastros/telemetria/tipo-outro-telemetria/tipo-outro-telemetria.module'
          ).then((m) => m.TipoOutroTelemetriaModule),
        data: {
          modulo: 'tipo-outro-telemetria', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'pragas-gerais-lancamento',
        loadChildren: () =>
          import(
            './pages/lancamentos/pragas-gerais/pragas-gerais-lancamento.module'
          ).then((m) => m.PragasGeraisLancamentoModule),
        data: {
          modulo: 'pragas-gerais-lancamento', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'pragas-gerais-lancamento-gerenciar',
        loadChildren: () =>
          import(
            './pages/lancamentos/pragas-gerais-gerenciar/pragas-gerais-lancamento-gerenciar.module'
          ).then((m) => m.PragasGeraisLancamentoGerenciarModule),
        data: {
          modulo: 'pragas-gerais-lancamento-gerenciar', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'greening-lancamento',
        loadChildren: () =>
          import(
            './pages/lancamentos/greening/greening-lancamento.module'
          ).then((m) => m.GreeningLancamentoModule),
        data: {
          modulo: 'greening-lancamento', // Usado pelo ModuloGuard
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
      {
        path: 'app-error-log',
        loadChildren: () =>
          import(
            './pages/administracao/app-error-log/app-error-log.module'
          ).then((m) => m.AppErrorLogModule),
        data: {
          modulo: 'app-error-log',
        },
        canMatch: [authGuard],
        canActivate: [ModuloGuard],
      },
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'authentication/error',
  },
];

@NgModule({
  // PreloadAllModules: depois do carregamento inicial, o Angular busca em segundo plano
  // (sem bloquear a tela) todos os módulos lazy das rotas — evita o atraso perceptível na
  // primeira navegação a cada módulo, que hoje faz o destaque do item de menu (dirigido por
  // NavigationEnd, que só dispara após o módulo carregar) parecer "não registrar o clique".
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
